import './chefric/style';
import FormStructure from './chefric/form_structure';

export default FormStructure;